<template>
  <div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-info">
      <b-row>
        <b-col xl="3" md="6">
          <stats-card type="gradient-info" icon="ni ni-chart-bar-32" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">
              RESPONDEN
            </h5>
            <span class="h2 font-weight-bold mb-0">{{ totalAlumni }}</span>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card type="gradient-info" icon="ni ni-chart-bar-32" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">
              RESPON RATE
            </h5>
            <span class="h2 font-weight-bold mb-0">{{ totalMengisi }}</span>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <!--Tables-->
            <b-row class="mt-2">
              <b-col xl="12" class="mb-5 mb-xl-0">
                <b-card body-class="p-0" header-class="border-0">
                  <template v-slot:header>
                    <b-row align-v="center">
                      <b-col>
                        <h3 class="mb-0">Data Hasil Survey</h3>
                      </b-col>
                      <!-- <b-col class="text-right">
                        <a href="#!" class="btn btn-sm btn-primary"><i class="ni ni-fat-add"></i>Tambah Data</a>
                      </b-col> -->
                    </b-row>
                  </template>

                  <div class="padding">
                    <div v-show="loading">
                      <Loading />
                    </div>
                    <b-col class="text-right">
                     <!-- <button @click="downloadFile()" class="btn btn-sm btn-default">
                        <i class="fa fa-download mr-2"></i>Download Data
                      </button> -->
                       <button class="btn btn-sm btn-default" v-b-modal.modal-prevent-download >
                        <i class="fa fa-download mr-2"></i>Download Data
                      </button>
                      <button class="btn btn-sm btn-info" v-b-modal.modal-prevent-filter>
                          <i class="fa fa-filter mr-2"></i>Filter Data
                      </button>
                    </b-col>
                    <v-client-table :data="tableData" :columns="columns" :options="options">
                      <template slot="no_pengisian" slot-scope="{ row }">
                        Pengisisan Ke- {{row.no_pengisian}}
                      </template>
                      <template slot="status_mengisi" slot-scope="{ row }">
                        <button v-if="row.status_mengisi == 1" class="btn btn-sm btn-success">
                          sudah
                        </button>
                        <button v-if="row.status_mengisi == 0" class="btn btn-sm btn-danger">
                          belum
                        </button>
                      </template>
                      <template slot="actions" slot-scope="{ row }">
                        <button @click="detailItem(row)" class="btn btn-sm btn-info"><i
                            class="ni ni-curved-next mr-1"></i>detail</button>
                      </template>
                    </v-client-table>
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <!--End tables-->
          </card>
        </b-col>
      </b-row>
    </b-container>
                  <!-- modal filer-->
      <b-modal class="b-modal.modal-lg" id="modal-prevent-filter" ref="modal" title="Filter Data Alumni">
      <div v-show="loading">
          <Loading/>
      </div>
      <form>
          <div class="row">
              <div class="col-12">
                  <label>Filter Tahun</label>
                  <select
                      name="id_tahun"
                      class="form-control border text-left mr-2"
                      v-model="selected_id_tahun">
                      <option value="" disabled="disabled">Pilih Filter Tahun</option>
                      <option value="1">Lulusan/Kompre</option>
                      <option value="2">Wisuda</option>
                  </select>
              </div>
          </div>
          <div
              v-if="errors.has('id_tahun')"
              class="alert alert-danger rounded mb-3"
              role="alert">
              Tahun Wajib diisi!
          </div>
          <div class="row mt-3" v-if="this.selected_id_tahun == 1 || this.selected_id_tahun == 2">
              <div class="col-12">
                  <label>Tahun</label>
                  <select
                      name="tahun"
                      @change="getFilterTahun"
                      class="form-control border text-left"
                      v-model="selected_tahun">
                      <option value="" disabled="disabled">Pilih Tahun Lulusan</option>
                      <option
                          v-for="periode in list_tahun_periode"
                          :key="periode.tahun"
                          :value="periode.tahun">
                          {{ periode.tahun }}
                      </option>
                  </select>
              </div>
          </div>
          <div
              v-if="errors.has('tahun')"
              class="alert alert-danger rounded mb-3"
              role="alert">
              Tahun Wajib diisi!
          </div>
      </form>
      </b-modal>
      <!-- end-modal filter-->

          <!-- modal download-->
    <b-modal class="b-modal.modal-lg" id="modal-prevent-download" ref="modal" title="Download Data Hasil Tracer" @ok="handleOkDownload">
      <div v-show="loading_download">
        <Loading />
      </div>
      <form>
        <div class="ml-3 text-right">
        <button @click="resetDownload()" class="btn btn-sm btn-dark">Reset Filter</button>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Jenis Download</label>
            <select name="jns_download" class="form-control border text-left mr-2" v-model="selected_download.jns_export" >
              <option value="" disabled="disabled">Pilih Jenis Download</option>
              <option value="iku">IKU 1 (Rumus: Kepdirjen 173/E/KPT/2023)</option>
              <option value="upload_pddikti">Upload PDDIKTI/Akreditasi/Kebutuhan PT</option>
              <option value="riwayat_pengisian">Riwayat Pengisian</option>
            </select>
          </div>
        </div>
        <div v-if="errors.has('jns_download')" class="alert alert-danger rounded mb-3" role="alert" >
          Jenis Wajib diisi!
        </div>
        <div class="div" v-if="selected_download.jns_export === 'iku'">
        <div class="row mt-3">
          <div class="col-12">
            <label>Tahun IKU</label>
            <select name="tahun" class="form-control border text-left mr-2" v-model="selected_download.tahun" >
              <option value="" disabled="disabled">Pilih Tahun</option>
              <option v-for="periode in list_tahun_periode" :key="periode.tahun" :value="periode.tahun" >
                {{ periode.tahun }}
              </option>
            </select>
          </div>
        </div>
        <!-- <div class="row mt-3" v-if="selected_download.jns_export === 'iku' && thn_iku != ''">
          <div class="col-12">
            <label>Tahun Lulus/Kompre</label>
            <input v-model="selected_download.tahun" :placeholder="tahunKompre" class="form-control border text-left mr-2" disabled/>
          </div>
        </div> -->
        </div>
        <div v-if="selected_download.jns_export !== 'iku'">
        <div class="row mt-3">
          <div class="col-12">
            <label>Tahun</label>
            <select name="id_tahun" class="form-control border text-left mr-2" v-model="selected_download.jns_tahun" >
              <option value="" disabled="disabled">Pilih Filter Tahun</option>
              <option value="kompre">Lulusan/Kompre</option>
              <option value="wisuda">Wisuda</option>
            </select>
          </div>
        </div>
         <div class="row mt-3" v-if="this.selected_download.jns_tahun !== ''" >
          <div class="col-12">
            <label>Tahun</label>
            <select name="tahun" class="form-control border text-left mr-2" v-model="selected_download.tahun" >
              <option value="" disabled="disabled">Pilih Tahun</option>
              <option v-for="periode in list_tahun_periode" :key="periode.tahun" :value="periode.tahun" >
                {{ periode.tahun }}
              </option>
            </select>
          </div>
        </div>
        <div v-if="errors.has('tahun')" class="alert alert-danger rounded mb-3" role="alert" >
          Tahun Wajib diisi!
        </div>
       </div>
      </form>

    </b-modal>
    <!-- end-modal download-->
  </div>
</template>
<script>
  import BaseHeader from "@/components/admin/BaseHeader";
  import DataService from "@/services/data.service";
  import Loading from "@/components/Loading.vue";

  export default {
    name: "Alumni",
    components: {
      BaseHeader,
      Loading
    },
    data() {
      return {
        // fakultas: [],
        // prodi: [],
        selected_download: {
            jns_export: "",
            jns_tahun: "kompre",
            tahun: "",
            kode_prodi: ""
        },
        selected_id_tahun: "",
        selected_tahun: "",
        list_tahun_periode: {},
        totalAlumni: "",
        totalMengisi: "",
        loading: false,
        loading_download: false,
        columns: [
          "wkt_pengisian",
          "no_pengisian",
          "id_alumni",
          "npm",
          "nama_lengkap",
          "nm_fakultas",
          "nm_program_studi",
          "tanggal_wisuda",
          "status_lulusan",
          "actions",
        ],
        tableData: [],
        selected_prodi: "",
        options: {
          headings: {
            wkt_pengisian: "Waktu Pengisian  ",
            no_pengisian: "No Urut Pengisian  ",
            username: "NPM  ",
            nama_lengkap: "Nama Lengkap  ",
            nm_fakultas: "fakultas  ",
            nm_program_studi: "Program Studi  ",
            tanggal_wisuda: "Tgl Wisuda  ",
            status_mengisi: "Status Lulusan ",
            actions: "Aksi "
          },
          sortable: true,
          filterable: true,
          hiddenColumns: ["id_alumni", "id_tracer"],
          texts: {
            count: "Menampilkan {from} sampai {to} dari {count} data|{count} data|Satu data",
            first: "Pertama",
            last: "Terahkir",
            filter: false,
            filterPlaceholder: "Pencarian",
            limit: false,
            page: "Page:",
            noResults: "Data tidak ada",
            loading: "Loading...",
            defaultOption: "Select {column}",
            columns: "Columns"
          },
          sortIcon: {
            is: "fa fa-sort",
            base: "font-awesome",
            up: "fa fa-angle-up",
            down: "fa fa-angle-down",
            align: "center"
          },
          pagination: {
            show: true,
            dropdown: false,
            chunk: 5,
            edge: false,
            align: "center",
            nav: "fixed"
          }
        }
      };
    },
    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      }
    },
  mounted() {
      // this.getFakultas();
      this.getTahun();
      this.getHasilTracer();
    },
    methods: {
      detailItem(row) {
        this.$router.push({
          name: 'detail-tracer-prodi',
          params: {
            id_alumni: row.id_alumni,
            id_tracer: row.id_tracer
          }
        })
      },
      getTahun() {
        DataService.getTahunPeriode()
          .then(res => {
            this.list_tahun_periode = res.data.tahunPeriode;
          })
          .catch(error => console.error(error));
      },
      getHasilTracer() {
        this.loading = true;
        DataService.getHasilTracerProdi(this.currentUser.user.username).then(res => {
          this.tableData = res.data.surveys;
          this.selected_prodi = this.tableData[0].id_program_studi;
          this.totalAlumni = res.data.totalAlumni;
          this.totalMengisi = res.data.totalMengisi;
          if (this.tableData) {
            this.loading = false;
               this.$nextTick(() => {
                 this.$bvModal.hide("modal-prevent-filter");
               });
            return;
          }
        });
      },
      getFilterTahun() {
        this.loading = true;
        DataService.getHasilTracerProdiChoise(this.selected_id_tahun, this.selected_tahun, this.currentUser.user.username)
          .then(res => {
            this.tableData = res.data.surveys;
            this.totalAlumni = res.data.totalAlumni;
            this.totalMengisi = res.data.totalMengisi;
            if (this.tableData) {
              this.loading = false;
               this.$nextTick(() => {
                 this.$bvModal.hide("modal-prevent-filter");
              });
              return;
            }
          })
          .catch(error => console.error(error));
      },
    downloadFile() {
      // if(this.selected === ""){
      //   this.$swal({ icon: "error", title: "Pilih tahun lulusan dahulu" });
      // }else{
      this.loading = true;
      DataService.downloadFileTracerProdi(this.selected_id_tahun, this.selected_tahun, this.currentUser.user.username)
        .then(res => {
          this.customDownload(res, "HasilSurvey");
              this.loading = false;
        })
        .catch(error => console.error(error));
        // }
    },
      customDownload(res, filename) {
      if (res.data) {
        this.loading = false;
      }
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([res.data], { type: "application/xlsx" });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download = filename + ".xlsx";
      link.click();
      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
      },
    // getFakultas(){
    //   DataService.getFaculties()
    //     .then(res => {
    //       this.fakultas = res.data.faculties;
    //     })
    //     .catch(error => console.error(error));
    // },
    // getProdi() {
    //   DataService.getProgramsChoise(this.selected_download.id_fakultas)
    //     .then(res => {
    //       this.prodi = res.data.studyPrograms;
    //     })
    //     .catch(error => console.error(error));
    //   },
    resetDownload() {
      this.selected_download = {
          jns_export: "",
          jns_tahun: "kompre",
          tahun: ""
      }
      },
        handleOkDownload(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmitDownload();
    },
    handleSubmitDownload() {
      // console.log(JSON.stringify(this.selected_download))
      if (this.selected_download.jns_export == "" || this.selected_download.jns_tahun == "" || this.selected_download.tahun == "") {
        this.$swal({ icon: "error", title: "Jenis download, Jenis tahun, dan tahun wajib diisi!" });
      } else {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-download");
      });
      this.loading = true;
        const data = {
            jns_export: this.selected_download.jns_export,
            jns_tahun: this.selected_download.jns_tahun,
            tahun: this.selected_download.tahun,
            kode_prodi: this.currentUser.user.username
        }
      DataService.exportTracerStudy(data)
        .then((res) => {
          this.customDownload(res, "HasilTracerStudy");
        })
        .catch((error) => {
          this.message =
            (error.data && error.data.error && error.response.data.error) ||
            error.message ||
            error.toString();
        });
      }
    },
    }
  };
</script>
<style scoped>
  .padding {
    padding: 20px !important;
  }
</style>
